import { render } from "./card_DatalistInModal.vue?vue&type=template&id=4057f41a&bindings={\"lang\":\"data\",\"last_length\":\"data\",\"partner_list\":\"data\",\"start_search\":\"data\",\"endpoint_partner_url\":\"data\",\"language\":\"setup\",\"close\":\"options\",\"setIcon\":\"options\",\"checkForListCust\":\"options\",\"setID\":\"options\",\"setCustomerToCluster\":\"options\"}"
import script from "./card_DatalistInModal.vue?vue&type=script&lang=js"
export * from "./card_DatalistInModal.vue?vue&type=script&lang=js"

import "./card_DatalistInModal.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script